import BackendService from 'BackendService';
import { InvestorDraft } from './veraGlobalChatPromptOverrideUtils';

export interface LoadedInvestorPrompts {
  productionMarkdown: string;
  markdown: string;
  intentText: string;
  intentProductionText: string;
  groundingText: string;
  groundingProductionText: string;
  globalSearchEnabled: boolean;
  globalSearchLinksEnabled: boolean;
}

export async function loadInitialInvestorPrompts(
  draft: InvestorDraft | null,
): Promise<LoadedInvestorPrompts> {
  const [system, intent, config, grounding] = await Promise.all([
    new BackendService().getVeraSystemPrompt(),
    new BackendService().getVeraIntentPrompt(),
    new BackendService().getGlobalConfiguration(),
    new BackendService().getVeraGlobalChatGroundingPrompt(),
  ]);

  const productionMarkdown = system.productionMarkdown ?? '';
  const markdown = draft?.markdown ?? productionMarkdown;
  const intentProductionText = intent.productionText;
  const intentText =
    draft?.intentText ??
    (intent.sandboxSource === 'custom' ? intent.sandboxText : intent.productionText);
  const groundingProductionText = grounding.productionText;
  const groundingText = draft?.groundingText ?? groundingProductionText;

  return {
    productionMarkdown,
    markdown,
    intentText,
    intentProductionText,
    groundingText,
    groundingProductionText,
    globalSearchEnabled: !!config.enableVeraGoogleSearchGrounding,
    globalSearchLinksEnabled: !!config.enableVeraGlobalChatSearchLinks,
  };
}
